import React, { Component } from 'react'
import { pathEq, pipe, pathOr } from 'ramda'
import { goToHomepage } from 'shared/helpers/user'
import { hasLength } from 'shared/helpers/functional'
import 'less/thankyou.less'

const paymentMessage = 'You should receive payment in your InCrowd account within 24 hours. If you have any questions, please contact us at qualinterviews@incrowdnow.com.'

class ThankYou extends Component {
  constructor (props) {
    super(props)
    this.state = {
      counter: 10,
      hasRoles: pipe(pathOr([], ['user', 'roles']), hasLength)(props),
    }
  }

  componentDidMount () {
    this.startCountDown()
  }

  startCountDown = () => {
    if (this.state.hasRoles) setInterval(this.countDown, 1000)
  }

  countDown = () => {
    if (this.state.counter) {
      this.setState({ counter: this.state.counter - 1 })
    }
  }

  redirectUser = () => {
    if (this.state.hasRoles) goToHomepage(this.props.user)
  }

  render () {
    return (
      <div className="thankyou">
        { this.state.counter ? <div className="message-box">
          <div className="logo-container">
            <img
              className="incrowd-logo"
              src="/images/IC-Interview-Color-No-Beta.svg"
              role="presentation"
            />
          </div>

          <h1 className="heading">Thank you for Participating.</h1>
          {this.state.hasRoles && <span className="description">
            You will be automatically redirected to the InCrowd Interview Dashboard in {this.state.counter} seconds.
          </span>}
          {pathEq(['match', 'params', 'role'], 'participant', this.props) && paymentMessage}
          {this.state.hasRoles && <button className="btn btn-primary" onClick={this.redirectUser}>InCrowd Interview Dashboard</button>}
        </div> : this.redirectUser()}
      </div>
    )
  }
}

export default ThankYou
